import React from "react";
import get from "lodash/get";
import { PAYWALL_BUTTONS, STATIC_KEYWORDS } from "../../../../constants";
import { Button } from "../../../../components/atoms";
import { useSelector } from "react-redux";
import { SocialLogin } from "../../../../components/molecules/SocialLogin";
import AccountModal from "../../../../components/login/AccountModal";

import "./paywall.m.css";

export const Paywall = ({ magazine = false }) => {
  const {
    SIGN_UP_LABEL,
    SIGN_UP_DESCRIPTION,
    CONTINUE_WITH,
    ENTER_EMAIL,
    CONTINUE,
    PRIVACY_POLICY,
    TERMS_AND_CONDITIONS,
    TERMS_PRE_TEXT,
  } = STATIC_KEYWORDS;

  return (
    <div styleName="paywall-container">
      <AccountModal customCallbackUrl={global?.location?.href} magazine={magazine} />
    </div>
  );
};
